<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <v-card>
      <v-card-title class="p-0 flex-nowrap flex-row headline">
        <v-icon color="primary">mdi-comment-text-outline</v-icon>
        <span class="pl-4 title">
          Comment for task:
          <strong>{{ name }}</strong>
        </span>
      </v-card-title>
      <template>
        <v-container fluid>
          <v-textarea
            class="pa-0"
            name="commentField"
            label="Comment"
            auto-grow
            v-model="comment"
          ></v-textarea>
        </v-container>
      </template>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          :loading="loading"
          :disabled="loading"
          text
          outlined
          @click="save"
        >
          <v-icon left>mdi-content-save-edit-outline</v-icon>
          Save
        </v-btn>
        <v-btn color="primary" text @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { tasksApiV1 } from '@/api/v1';
import { tasksApiV2 } from '@/api/v2';

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      name: '',
      comment: '',
      taskId: ''
    };
  },
  methods: {
    open({ taskId, comment, name }) {
      this.name = name;
      this.comment = comment;
      this.taskId = taskId;
      this.dialog = true;
    },
    async save() {
      this.loading = true;
      await (
        this.$store.getters.getFeatureToggleByNameEnabled('matcher_api_v2')
          ? tasksApiV2
          : tasksApiV1
      ).updateTask(this.taskId, { comment: this.comment });
      this.loading = false;
      this.dialog = false;
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
